import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import PlanificateurIntegre from "components/PlanificateurIntegre/PlanificateurIntegre";
import PlanificateurResumeIntegre from "components/PlanificateurResumeIntegre/PlanificateurResumeIntegre";
import SectionCarteIntegre from "./SectionCarteIntegre";
import BudgetPageIntegre from "./BudgetPageIntegre";
import React, { FC, useEffect, useState, useContext, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import CommonLayout from "./CommonLayout";
import { voyageService } from '_services/voyage.service';
import { VoyagePlanificateurType, JourneeType, EventType } from "data/types";
import AppContext from 'AppContext';
import Lottie from 'lottie-react';
import animationData from '../../shared/loading.json';
import { useTranslation } from 'react-i18next';
 
export interface PagePlanificateurIntegreProps {
  className?: string;
}

const PagePlanificateurIntegre: FC<PagePlanificateurIntegreProps> = ({ className = "" }) => {
  const { t } = useTranslation();
  
  const { setVoyageInfo, setAfficheMenuMobile, ajoutIncontournable, setAjoutIncontournable } = useContext(AppContext);
  const { voyageKey } = useParams<{ voyageKey: string }>();
  const { vue } = useParams<{ vue: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [eventCategoriesPage, setEventCategoriesPage] = useState<JourneeType[]>([]);
  const [voyage, setVoyage] = useState<VoyagePlanificateurType>();
  const [menu, setMenu] = useState<string>(vue || 'planning');
  const [affichageBudget, setAffichageBudget] = useState<string>("N");
  const [fraisVisa, setFraisVisa] = useState<number>(0.0);
  const [fraisVaccins, setFraisVaccins] = useState<number>(0.0);
  const [fraisMateriel, setFraisMateriel] = useState<number>(0.0);
  const [fraisCarburant, setFraisCarburant] = useState<number>(0.0);
  const [fraisVehicule, setFraisVehicule] = useState<number>(0.0);
  const [fraisNourriture, setFraisNourriture] = useState<number>(0.0);
  const [fraisAutre, setFraisAutre] = useState<number>(0.0);
  const [etatPaiementVisa, setEtatPaiementVisa] = useState<string>("");
  const [etatPaiementVaccins, setEtatPaiementVaccins] = useState<string>("");
  const [etatPaiementMateriel, setEtatPaiementMateriel] = useState<string>("");
  const [etatPaiementCarburant, setEtatPaiementCarburant] = useState<string>("");
  const [etatPaiementVehicule, setEtatPaiementVehicule] = useState<string>("");
  const [etatPaiementNourriture, setEtatPaiementNourriture] = useState<string>("");
  const [etatPaiementAutre, setEtatPaiementAutre] = useState<string>("");
  const [infosFrais, setInfosFrais] = useState<string>("");
  const [fraisPerso, setFraisPerso] = useState<any[]>([]);

  let { mode } = useParams<{ mode: string }>();
  if(mode === undefined || mode === null || mode !== "modification")
  {
    mode="consultation";
  }

  useEffect(() => {
    setAfficheMenuMobile(true);
    if (!voyageKey) {
      // Redirect to the home page if voyageKey is not provided
      navigate("/");
    }
  }, [navigate, voyageKey]);

  

  const formattedVoyageKey = voyageKey || "";

  useEffect(() => {

    const fetchEventData = async () => {
      try {

        const response = await voyageService.getVoyageIntegre(voyageKey);
        const voyage = response.data.voyage;

        setVoyage(voyage);

        setVoyageInfo({
          id_voyage: voyage.id_voyage, 
          num_droit: voyage.num_droit,
          nb_jours: voyage.nb_jours,
          etatVoyage: voyage.etatVoyage, 
          date_deb_formate: voyage.date_deb_formate, 
          date_fin_formate: voyage.date_fin_formate, 
          nb_voyageurs:voyage.nb_voyageurs,
          id_pays:voyage.id_pays,
          libelles_pays:voyage.libelles_pays,
          monnaie:voyage.monnaie,
          symbole_monnaie:voyage.symbole_monnaie,
          ville:voyage.ville
        });
        

        if(voyage.affichage_budget === 'O' && voyage.affichage_prix !== 'O')
        {
          setAffichageBudget(voyage.affichage_prix); // Sinon onglet budget vide
        }
        else
        {
          setAffichageBudget(voyage.affichage_budget);
        }
        setFraisVisa(voyage.frais_visa);
        setFraisVaccins(voyage.frais_vaccins);
        setFraisVehicule(voyage.frais_vehicule);
        setFraisCarburant(voyage.frais_carburant);
        setFraisNourriture(voyage.frais_nourriture);
        setFraisMateriel(voyage.frais_materiel);
        setFraisAutre(voyage.frais_autre);
        setEtatPaiementVisa(voyage.etat_paiement_visa);
        setEtatPaiementVaccins(voyage.etat_paiement_vaccins);
        setEtatPaiementVehicule(voyage.etat_paiement_vehicule);
        setEtatPaiementCarburant(voyage.etat_paiement_carburant);
        setEtatPaiementNourriture(voyage.etat_paiement_nourriture);
        setEtatPaiementMateriel(voyage.etat_paiement_materiel);
        setEtatPaiementAutre(voyage.etat_paiement_autre);
        setInfosFrais(voyage.infos_frais);
        setFraisPerso(voyage.fraisPerso);

        const eventCategoriesPage = response.data.voyage.groupedResults || [];
        setEventCategoriesPage(eventCategoriesPage);


      } catch (error: any) {
    
        console.error("Error fetching data:", error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };
  
    fetchEventData();

  }, [mode, voyageKey]);

  const handleMenuChange = (nomMenu: string) => {
    setMenu(nomMenu);
  };

  if (loading) {
    return <div className="text-center mt-20 mb-20">
      <div className="mx-auto h-[200px] w-[200px]">
              <Lottie
                animationData={animationData}
                loop
                autoplay
              />
            </div>
      <h1 className="text-xl">{t('chargementVoyage')}</h1>
      </div>;
  }

  return (
    <div
      className={`nc-PagePlanificateurIntegre relative`}
      data-nc-id="PagePlanificateurIntegre"
    >
      <Helmet>
        <title>Itinéraire créé sur le planificateur de voyages tripkygo</title>
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative container-integre">

        {/* SECTION 1 */}
        <CommonLayout onClickMenu={handleMenuChange} 
                      affichageBudget={affichageBudget}
                      numDroit={voyage?.num_droit ? voyage?.num_droit : voyage?.num_droit === 0 ? 0 : 999}
                      classLayout={"layout-integre"}
                      username={voyage?.username || '' }
                      avatar={voyage?.avatar || '' }
                      vue={vue || 'planning'}
                      idVoyage={voyage?.id_voyage || 0} 
                      >
        <div className="relative py-6">
<BackgroundSection
  largeur="nolargeur"
  className="
    overflow-hidden

    border
    border-white/90
    dark:border-white/10

    bg-[linear-gradient(135deg,#FCFBF8_0%,#FAF9F6_52%,#F7F6F3_100%)]

    shadow-[0_28px_80px_rgba(15,23,42,0.075),inset_0_1px_0_rgba(255,255,255,0.95)]

    dark:bg-[linear-gradient(135deg,#0F172A_0%,#111827_52%,#161B2A_100%)]
    dark:shadow-[0_28px_80px_rgba(0,0,0,0.34)]
  "
>
  <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">

    {/* Très légère lumière chaude à gauche */}
    <div
      className="
        absolute
        inset-0
        bg-[radial-gradient(circle_at_8%_22%,rgba(217,207,191,0.16)_0%,rgba(217,207,191,0.07)_25%,transparent_48%)]
        dark:bg-[radial-gradient(circle_at_8%_22%,rgba(148,163,184,0.055)_0%,transparent_46%)]
      "
    />

    {/* Très légère nuance froide à droite */}
    <div
      className="
        absolute
        inset-0
        bg-[radial-gradient(circle_at_88%_70%,rgba(203,213,225,0.10)_0%,transparent_43%)]
        dark:bg-[radial-gradient(circle_at_88%_70%,rgba(99,102,241,0.045)_0%,transparent_44%)]
      "
    />

    {/* Cercles concentriques discrets à gauche */}
    <div
      className={`
        absolute
        inset-0
        dark:opacity-0
        ${
          menu === "planning"
            ? "opacity-[0.22]"
            : "opacity-[0.22]"
        }
        [background-image:repeating-radial-gradient(circle_at_10%_28%,rgba(148,138,124,0.28)_0px,rgba(148,138,124,0.28)_1px,transparent_1px,transparent_42px)]
      `}
    />

    {/* Grandes lignes concentriques très fines */}
    <div
      className="
        absolute
        inset-0
        opacity-[0.10]
        dark:opacity-[0.025]
        [background-image:repeating-radial-gradient(ellipse_at_54%_62%,rgba(148,138,124,0.25)_0px,rgba(148,138,124,0.25)_1px,transparent_1px,transparent_58px)]
      "
    />

    {/* Voile blanc pour garder le motif subtil */}
    <div
      className="
        absolute
        inset-0
        bg-white/28
        dark:bg-slate-950/25
      "
    />

    {/* Fine lumière intérieure en haut */}
    <div
      className="
        absolute
        inset-x-0
        top-0
        h-px
        bg-white/90
        dark:bg-white/10
      "
    />
  </div>
</BackgroundSection>
          { menu === 'planning' && (
          <PlanificateurIntegre
            key={`${mode}-${formattedVoyageKey}`} 
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
            uniqueClassName="ListingStayMapPage"
            voyageKey={formattedVoyageKey}
            emailPartage={""}
            codePartage={""}
            mode={mode}
            eventCategoriesPage={eventCategoriesPage}
            id_pays={voyage?.id_pays || ''}
            nbJours={voyage?.groupedResults.length || 0}
            monnaie={voyage?.monnaie || "EUR"}
            symbole_monnaie={voyage?.symbole_monnaie || "€"}
            visibilite={voyage?.visibilite || ''}
            etatVoyage={voyage?.etatVoyage || 0 }
            nb_voyageurs={voyage?.nb_voyageurs || 0 }
            numDroit={voyage?.num_droit ? voyage?.num_droit : voyage?.num_droit === 0 ? 0 : 999}
            username={voyage?.username || '' }
          />
          )}

        { menu === 'resume' && (
          <PlanificateurResumeIntegre
            key={`${mode}-${formattedVoyageKey}`} 
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
            uniqueClassName="ListingStayMapPage"
            voyageKey={formattedVoyageKey}
            emailPartage={""}
            codePartage={""}
            mode={mode}
            eventCategoriesPage={eventCategoriesPage}
            id_pays={voyage?.id_pays || ''}
            libelles_pays={voyage?.libelles_pays || ''}
            nbJours={voyage?.groupedResults.length || 0}
            monnaie={voyage?.monnaie || "EUR"}
            symbole_monnaie={voyage?.symbole_monnaie || "€"}
            visibilite={voyage?.visibilite || ''}
            etatVoyage={voyage?.etatVoyage || 0 }
            nb_voyageurs={voyage?.nb_voyageurs || 0 }
            numDroit={voyage?.num_droit ? voyage?.num_droit : voyage?.num_droit === 0 ? 0 : 999}
            username={voyage?.username || '' }
          />
          )}

          { menu === 'carte' && (
            <div className="containerCarteIntegre pb-24 lg:pb-28 2xl:pl-10 xl:pr-0 xl:max-w-none">
              <SectionCarteIntegre 
              voyageKey={formattedVoyageKey}
              emailPartage={""}
              codePartage={""}
              eventCategoriesPage={eventCategoriesPage}
              etatVoyage={voyage?.etatVoyage || 0 }
              id_pays={voyage?.id_pays || ''}
              numDroit={voyage?.num_droit ? voyage?.num_droit : voyage?.num_droit === 0 ? 0 : 999}
              symbole_monnaie={voyage?.symbole_monnaie || '€'}
              nb_voyageurs={voyage?.nb_voyageurs || 0 }
                />
            </div>
          )}

          { menu === 'budget' && (
            <div className="container pb-24 lg:pb-28 2xl:pl-10 xl:pr-0 xl:max-w-none">
              <BudgetPageIntegre
              voyageKey={formattedVoyageKey}
              emailPartage={""}
              codePartage={""}
              symbole_monnaie={voyage?.symbole_monnaie || "€"}
              nb_voyageurs={voyage?.nb_voyageurs || 0 }
              nb_jours={voyage?.nb_jours || 0 }
              numDroit={voyage?.num_droit ? voyage?.num_droit : voyage?.num_droit === 0 ? 0 : 999}
              eventCategoriesPage={eventCategoriesPage}
              fraisVisa={fraisVisa}
              fraisVaccins={fraisVaccins}
              fraisMateriel={fraisMateriel}
              fraisNourriture={fraisNourriture}
              fraisCarburant={fraisCarburant}
              fraisVehicule={fraisVehicule}
              fraisAutre={fraisAutre}
              infosFrais={infosFrais}
              etatPaiementVisa={etatPaiementVisa}
              etatPaiementVaccins={etatPaiementVaccins}
              etatPaiementMateriel={etatPaiementMateriel}
              etatPaiementNourriture={etatPaiementNourriture}
              etatPaiementCarburant={etatPaiementCarburant}
              etatPaiementVehicule={etatPaiementVehicule}
              etatPaiementAutre={etatPaiementAutre}
              fraisPerso={fraisPerso}
               />
            </div>
          )}
        </div>
        </CommonLayout>
      </div>
    </div>
  );
};

export default PagePlanificateurIntegre;